var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { LinkButton } from '@components/forms';
import { Icon } from '@components/icon';
import { t } from '@containers/helpers/tests';
import React, { Component } from 'react';
import { MarketData } from '../../.';
import styles from './marketDataLink.less';
var anySection = {
    category: 'any',
    section: '',
};
var MarketDataLink = /** @class */ (function (_super) {
    __extends(MarketDataLink, _super);
    function MarketDataLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false,
        };
        _this.handleOpen = function () {
            _this.setState(function (state) { return ({
                open: !state.open,
            }); });
        };
        return _this;
    }
    MarketDataLink.prototype.render = function () {
        var _a = this.props, section = _a.section, event = _a.event, listingType = _a.listingType;
        return React.createElement(React.Fragment, null,
            this.renderLink(),
            React.createElement(MarketData, { open: this.state.open, eventSummary: event, handleClose: this.handleOpen, initialTab: listingType, listingSection: section || anySection }));
    };
    MarketDataLink.prototype.renderLink = function () {
        return (React.createElement(LinkButton, __assign({ className: styles.trigger, onClick: this.handleOpen }, t('MarketDataLink')), !this.props.icon ? 'Market data' : React.createElement(Icon, { icon: 'help-me-price', width: 14 })));
    };
    return MarketDataLink;
}(Component));
export { MarketDataLink };
